import ImageViewer from "@shared/ui/hook-form/image-control/image-viewer/image-viewer";
import "./parent-info.scss";
import { Divider } from "primereact/divider";
import { GoPersonFill } from "react-icons/go";
import { ReactNode } from "react";
import { GetMemberModel } from "@factory/model/query-model-member";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import TextBlock from "@shared/ui/text-block/text-block";
import { MemberFormSchema } from "@factory/form/form.rule";

export interface ParentInfoProps {
  name?: string;
  photo?: string;
  role?: string;
  children?: ReactNode;
}

export function ParentInfo({ name, photo, role = "Parent", children }: ParentInfoProps) {
  return (
    <div id="ParentInfo" className="parent-info border p-6 rounded-lg m-4">
      <div className="flex items-center gap-4">
        {photo ? (
          <ImageViewer image={photo} className="w-20 h-20 rounded-full" />
        ) : (
          <span className="border rounded-full p-3">
            <GoPersonFill />
          </span>
        )}
        <div className="flex flex-col">
          <span className="font-bold">{name}</span>
        </div>
      </div>
      <Divider />
      {children}
    </div>
  );
}

export interface ParentInfoMemberProps {
  model: MemberFormSchema;
  role?: string;
}
export function ParentInfoMember({ model, role }: ParentInfoMemberProps) {
  const { formatDate } = useDateTimeContext();
  return (
    <div id="ParentInfoMember">
      <ParentInfo
        name={`${model?.firstName} ${model?.lastName}`}
        photo={model?.photo}
        role={role}
      >
        {model?.email && <TextBlock label="Email" value={model?.email} />}
        <TextBlock label="Mobile" value={model?.mobileNumber} />
        {model?.birthday && (
          <TextBlock label="Birthday" value={formatDate(model?.birthday)} />
        )}
      </ParentInfo>
    </div>
  );
}

export default ParentInfo;
